var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDefectDetection = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#42A5F2",
  d: "M12.6 18.4C8.4 18.4 5 15 5 10.8s3.4-7.6 7.6-7.6 7.6 3.4 7.6 7.6-3.4 7.6-7.6 7.6m0-14.3C9 4.1 6 7.1 6 10.7s3 6.6 6.6 6.6 6.6-3 6.6-6.6-2.9-6.6-6.6-6.6"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#42A5F2",
  d: "M22.5 22.9c-.1 0-.3-.1-.4-.2l-5.5-5.9c-.2-.2-.2-.5 0-.7s.5-.2.7 0l5.5 5.9c.2.2.2.5 0 .7-.1.1-.2.2-.3.2"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#BAD5DB",
  d: "M24.2 17c-.3 0-.5-.2-.5-.5v-6.1h-2c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h3v7.1c0 .3-.2.5-.5.5M1.8 17c-.3 0-.5-.2-.5-.5V9.4h2.4c.3 0 .5.2.5.5s-.2.5-.5.5H2.3v6.1c0 .3-.2.5-.5.5"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#86A7B2",
  d: "m14.2 14.3-1.8-4.8-2.1 3L8.7 9l-.7.9c-.2.2-.5.3-.7.1-.2-.1-.3-.4-.1-.7L8.9 7l1.6 3.4 2.2-3.2 1.7 4.7 1.2-2.1h2.6c.3 0 .5.2.5.5s-.2.5-.5.5h-2z"
})));
export default SvgDefectDetection;